var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgLogout(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 22,
    viewBox: "0 0 22 22",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.9583 4.03387C15.356 2.66207 13.2747 1.8335 11 1.8335C5.93738 1.8335 1.83333 5.93755 1.83333 11.0002C1.83333 16.0627 5.93738 20.1668 11 20.1668C13.2747 20.1668 15.356 19.3383 16.9583 17.9665",
    stroke: "#ED0505",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M16.5 7.3335C16.5 7.3335 20.1667 10.034 20.1667 11.0002C20.1667 11.9664 16.5 14.6668 16.5 14.6668M19.7083 11.0002H8.25",
    stroke: "#ED0505",
    strokeWidth: 1.3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogout);
export default __webpack_public_path__ + "static/media/logout.e9e770db365854f1be2f8df62b7502ff.svg";
export { ForwardRef as ReactComponent };